import { Record, type RecordOf } from 'immutable';

import { resourceStoreTypes } from 'app-components/flux/core';
import type { QcsSyncResourceStore } from 'app-components/flux/core/resourceStoreTypes';

import type { PreferenceV2Name, PreferenceV2Value } from './preferencesV2Names';

export const PREFERENCES_V2_REDUCER_KEY = 'preferencesV2Store';
export type PreferenceDataType = 'STRING' | 'NUMBER' | 'BOOLEAN' | 'JSON' | 'ARRAY';
export type PlannedSpendingListType = 'card' | 'row' | undefined;
export type GsfStage =
  | 'greeting'
  | 'nameZip'
  | 'businessEntry'
  | 'businessList'
  | 'businessGoals'
  | 'fiMultiSelect'
  | 'fiConnectList'
  | 'fiAccountsSummary'
  | 'FILauncher'
  | 'billScoutWaiter'
  | 'income'
  | 'bills'
  | 'finalRedirect'
  | 'completed_gsf'
  | 'fiManageSchedule';
export type PreferenceType = 'USER' | 'SYSTEM';
export type PreferenceScope = 'DATASET' | 'USER';
export type PreferenceV2Props = {
  clientId?: string;
  id?: PreferenceV2Name; // same as name - use it as a key (real qcs id is in preferenceId)
  isDeleted?: boolean;
  preferenceType?: PreferenceType;
  name?: PreferenceV2Name;
  dataType?: PreferenceDataType;
  label?: string;
  value?: unknown;
  createdAt?: string;
  modifiedAt?: string;
  scope?: PreferenceScope;
  preferenceId?: string; // real qcs id (we abuse 'id' = 'name' to use it as a key for convenience)
  preferenceName?: PreferenceV2Name; // used in POST to /v2/preferences/override; do not read from GET responses as it may not be present
};
export type PreferenceV2 = RecordOf<PreferenceV2Props>;
/** A preference record whose value has its name's type. */
export type PreferenceV2Record<Name extends PreferenceV2Name> = RecordOf<
  Omit<PreferenceV2Props, 'value'> & { value?: PreferenceV2Value<Name> }
>;

export const mkPreferencesV2Store = resourceStoreTypes.createTypedQcsSyncResourceStoreFactory<PreferenceV2Props>();
export const mkPreferencesV2Payload = resourceStoreTypes.createTypedQcsSyncResourcePayloadFactory<PreferenceV2Props>();

export const mkPreferenceV2 = Record<PreferenceV2Props>({
  clientId: undefined,
  id: undefined,
  isDeleted: undefined,
  preferenceType: undefined,
  name: undefined,
  dataType: undefined,
  label: undefined,
  value: undefined,
  createdAt: undefined,
  modifiedAt: undefined,
  scope: undefined,
  preferenceId: undefined,
  preferenceName: undefined,
});

export type PreferencesV2Store = QcsSyncResourceStore<PreferenceV2Props>;

export type PreferenceOverrideBumpResource = {
  id?: string;
  createdAt?: string;
  modifiedAt?: string;
  qcsId?: string;
  datasetId?: string;
  preferenceName?: PreferenceV2Name;
  value?: any;
};

declare module 'app-components/utils/redux-store/rootState' {
  export default interface RootState {
    [PREFERENCES_V2_REDUCER_KEY]: PreferencesV2Store;
  }
}
